import React, { useEffect, useState } from "react"
import { Table, Col, Row } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import { usePermissions } from "API/PermissionContext"

const ServiceItems = props => {
  const { canAdd, canEdit, canDelete, MODULE } = usePermissions()
  const MID = MODULE.CONFIGURATIONS
  const [serviceItems, setServiceItems] = useState([])
  const [deleteId, setDeleteId] = useState("")
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [search, setSearch] = useState({ name: '' })
  const [checkedItems, setCheckedItems] = useState([])
  const [parentChecked, setParentChecked] = useState(false)
  const [load, setLoad] = useState(false)
  const [showFilter, setShowFilter] = useState(false)

  useEffect(() => { fetchData() }, [load])

  const fetchData = async () => {
    try {
      const response = await api.get("service-items")
      const data = Array.isArray(response.data.data) ? response.data.data : []
      setServiceItems(data)
      setCheckedItems(new Array(data.length).fill(false))
    } catch (e) {
      console.error("Failed to load service items:", e)
    }
  }

  const fetchDelete = async () => {
    try {
      await api.delete("service-items/" + deleteId)
      setLoad(!load)
    } catch (e) {
      console.error("Delete failed:", e)
    }
  }

  const handleCheckboxChange = (i) => {
    const newCheckedItems = [...checkedItems]
    newCheckedItems[i] = !newCheckedItems[i]
    setCheckedItems(newCheckedItems)
    setParentChecked(newCheckedItems.every((item) => item))
  }
  const handleParentCheckboxChange = () => {
    const newParentChecked = !parentChecked
    setParentChecked(newParentChecked)
    setCheckedItems(new Array(serviceItems.length).fill(newParentChecked))
  }
  const removeFilter = () => {
    setSearch({ name: '' })
    setShowFilter(!showFilter)
  }

  return (
    <>
      <div className="dashBody">
        <button className="filter_rel btn btn-primary" onClick={() => removeFilter()}>
          <i className="fa fa-filter"></i>
          {showFilter && <i className="rel_filter_ban fa fa-ban"></i>}
        </button>
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Service Items</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              {canAdd(MID) && (
                <Link className="dashBtn" to="/add-service-item">
                  <i className="fas fa-plus-square"></i> Add New
                </Link>
              )}
              <Link className="dashBtn" to="/service-types" style={{ marginLeft: 10 }}>
                <i className="fas fa-arrow-left"></i> Service Types
              </Link>
            </Col>
          </Row>
        </div>
        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl" id="serviceItems">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckboxChange} /></th>
                <th>S.No</th>
                <th>Service Type</th>
                <th>Item Name</th>
                <th>Price</th>
                <th>Unit</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td><td></td>
                  <td><input type="text" className="form-control material_unit_type_sub"
                    onChange={e => setSearch({...search, name: e.target.value})}
                    value={search.name} placeholder="Search by name" /></td>
                  <td></td><td></td><td></td>
                  <td><a className="btn btn-block btn-success applyFilter" title="Apply Filter"><i className="fa fa-search"></i> Apply</a></td>
                </tr>
              )}
              {serviceItems.length > 0 ? (
                serviceItems.filter(item =>
                  (item.name || "").toLowerCase().includes(search.name.toLowerCase())
                ).map((si, i) => (
                  <tr key={i}>
                    <td><input type="checkbox" checked={checkedItems[i]} onChange={() => handleCheckboxChange(i)} /></td>
                    <td>{i + 1}</td>
                    <td>{si.service_type_name}</td>
                    <td>{si.name}</td>
                    <td>₹{si.price || '0'}</td>
                    <td>{si.unit || '-'}</td>
                    <td>
                      <span className={`badge ${si.status === 'active' ? 'bg-success' : 'bg-danger'}`}>
                        {si.status}
                      </span>
                    </td>
                    <td>
                      {canEdit(MID) && <Link to={"/edit-service-item/" + si.id}><i className="fas fa-edit icons icon-edit"></i></Link>}
                      {canDelete(MID) && <i className="fas fa-trash-alt icons icon-delete"
                        onClick={() => { setDeleteId(si.id); setconfirm_alert(true) }}></i>}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={8}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { fetchDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Service item deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default ServiceItems
